// The web app holds no encryption key: anything shipped in the browser bundle can be read by
// every visitor, so it could never stay secret. Requests carry "X-Client: web" (api/axios.js)
// and the backend answers with plain JSON over HTTPS: { result: <data> }.
//
// decodeParams keeps its old name so the callers did not have to change.
export function decodeParams(result) {
  if (result && typeof result === 'object') return result;
  if (typeof result === 'string') {
    // an encrypted string means the backend did not see the X-Client header
    console.error('Received an encrypted response; is the X-Client: web header being sent?');
  }
  return null;
}
